module.exports = __webpack_public_path__ + "img/just-wanna-try.6c13565e.png";